export default __webpack_public_path__ + "static/media/expl-nn_07_EN.29a9d56d.png";